import * as React from 'react';

function SvgIconIntroWechat(props) {
  return (
    <svg viewBox="0 0 47 39" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M35.88 15.84c-.85-.24-1.73-.4-2.62-.47v-.2c-1.2-5.53-7.18-9.7-13.93-9.7-7.62 0-13.83 5.28-13.83 11.77 0 3.49 1.8 6.63 5.18 9.1L9.5 29.87a.6.6 0 00.57.8.6.6 0 00.27-.07l4.44-2.2.55.1c1.37.28 2.55.52 4 .52.43 0 .86-.02 1.29-.05a.6.6 0 00.41-.23c1.6 3.98 6.02 6.85 11.2 6.85 1.34 0 2.68-.31 3.9-.61l3.41 1.85a.6.6 0 00.67-.05.6.6 0 00.2-.64l-.88-2.89c2.93-2.3 4.54-5.05 4.54-7.8 0-3.73-2.51-7.07-6.14-8.83"
          fill="#FCCE01"
        />
        <path
          d="M39.84 37.78l-3.63-1.97a18 18 0 01-4.3.65c-5.7 0-10.82-2.98-13-7.5-.57.06-1.07.08-1.57.08-1.71 0-3.07-.28-4.65-.6l-.4-.08-4.8 2.39a1.38 1.38 0 01-1.51-.19 1.36 1.36 0 01-.4-1.46l1.17-3.53C3 22.7 1.02 19.06 1.02 15.04c0-7.71 7.32-13.99 16.32-13.99 3.82 0 7.6 1.16 10.61 3.26 2.97 2.07 5 4.9 5.74 7.99.86.1 1.7.26 2.54.5a.69.69 0 11-.39 1.32 14.2 14.2 0 00-2.82-.5.7.7 0 01-.63-.78C31.09 6.9 24.63 2.43 17.34 2.43 9.1 2.43 2.4 8.09 2.4 15.04c0 3.7 1.93 7.07 5.58 9.73.24.18.34.49.24.77L6.9 29.51l5-2.49a.7.7 0 01.45-.06l.63.13c1.5.31 2.8.57 4.37.57.45 0 .91-.02 1.38-.05a.7.7 0 011.18.17c1.76 4.37 6.59 7.31 12.02 7.31 1.38 0 2.78-.32 4.22-.68a.7.7 0 01.5.07l3.84 2.08-.98-3.23a.68.68 0 01.23-.74c3.14-2.46 4.87-5.4 4.87-8.27 0-3.82-2.32-7.29-5.77-9.02a.69.69 0 01-.31-.92c.16-.34.6-.5.92-.32 1.74.98 3.19 2.22 4.48 4.04a10.74 10.74 0 012.06 6.22c0 3.18-1.78 6.38-5.02 9.05l.85 2.82c.16.53-.01 1.1-.45 1.46a1.38 1.38 0 01-1.52.13z"
          stroke="#4C4C4C"
          strokeWidth={0.76}
          fill="#4C4C4C"
        />
        <path
          d="M22.94 12.44c1.12 0 1.87-.75 1.87-1.86 0-1.12-.75-1.85-1.87-1.85s-2.25.73-2.25 1.85c0 1.11 1.13 1.86 2.25 1.86zm-10.46-3.7c-1.12 0-2.25.72-2.25 1.84 0 1.11 1.13 1.86 2.25 1.86s1.87-.75 1.87-1.86c0-1.12-.75-1.85-1.87-1.85z"
          fill="#4C4C4C"
        />
        <path
          d="M19.27 28.57a.7.7 0 01-.67-.5 18.6 18.6 0 01-.46-3.75c0-2.88 1.25-5.68 3.51-7.89 2.2-2.14 5.2-3.58 8.44-4.06a.69.69 0 01.2 1.36c-6.14.9-10.77 5.46-10.77 10.6 0 .82.2 2.57.42 3.37a.69.69 0 01-.67.87z"
          stroke="#4C4C4C"
          strokeWidth={0.76}
          fill="#4C4C4C"
        />
        <path
          d="M27.8 19.5c-.75 0-1.5.75-1.5 1.49s.75 1.48 1.5 1.48c1.12 0 1.86-.74 1.86-1.48 0-.75-.74-1.5-1.86-1.5zm8.21 0c-.74 0-1.48.75-1.48 1.49s.74 1.48 1.48 1.48c1.12 0 1.88-.74 1.88-1.48 0-.75-.76-1.5-1.88-1.5z"
          fill="#4C4C4C"
        />
      </g>
    </svg>
  );
}

export default SvgIconIntroWechat;
